import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LocalStorageKeys } from '@app/services/local-storage.service';

@Component({
  standalone: false,
  selector: 'ti-background-job-result',
  templateUrl: './background-job-result.component.html',
  styleUrls: ['./background-job-result.component.sass'],
})
export class BackgroundJobResultComponent {
  readonly localStorageKeys = LocalStorageKeys;
  readonly strings = tiStrings.services.backgroundJobs.components.stringsBackgroundJobResult;
  readonly appStrings = tiStrings.app.misc;

  @Output() close = new EventEmitter();
  @Input() errors: { name: string; description: string }[];
  @Input() text: string;
  @Input() link: string;

  onClose(): void {
    this.close.emit();
  }
}
